import DropdownMenu, { ActionsProps } from "../../Inputs/DropdownMenu";
import { ButtonLink } from "../ButtonLink";
import { Body } from "../Typography";
import {
  CollaboratorActions,
  CollaboratorContent,
  CollaboratorRowContainer,
  CollaboratorTextContent,
} from "./__styles__/CollaboratorList";
import { Collaborator, PermissionOption } from "./types";

interface CollaboratorRowProps {
  collaborator: Collaborator;
  permissionOptions: PermissionOption[];
  onPermissionChange: (collaboratorId: string, permission: string) => void;
  onRemove: (collaboratorId: string) => void;
  showPermissionOptions?: boolean;
}

export const CollaboratorRow = ({
  collaborator,
  permissionOptions,
  onPermissionChange,
  onRemove,
  showPermissionOptions = true,
}: CollaboratorRowProps) => {
  const currentPermissionLabel =
    permissionOptions.find(opt => opt.value === collaborator.permission)
      ?.label || "Can view";
  // In the share workflow UI, we show the public user's group name (e.g., "Homeowner")
  // instead of a permission level since only "view" applies.
  const displayLabel =
    showPermissionOptions ?
      currentPermissionLabel
    : (collaborator.role ?? "Unknown");

  const dropdownActions: ActionsProps[] = [
    {
      label: "Remove",
      onClick: () => onRemove(collaborator.id),
      variant: "red" as const,
    },
  ];

  if (showPermissionOptions) {
    dropdownActions.push(
      ...permissionOptions.map(option => ({
        label: option.label,
        onClick: () => onPermissionChange(collaborator.id, option.value),
      })),
    );
  }

  return (
    <CollaboratorRowContainer>
      <CollaboratorContent>
        <CollaboratorTextContent>
          <Body type="emphasis" size="default" color="contentPrimary">
            {collaborator.name}
          </Body>
          {collaborator.description && (
            <Body type="regular" size="default" color="contentSecondary">
              {collaborator.description}
            </Body>
          )}
        </CollaboratorTextContent>
      </CollaboratorContent>
      <CollaboratorActions>
        <DropdownMenu
          actions={dropdownActions}
          position="below-left"
          customButton={({ onPress }) => (
            <ButtonLink
              styleVariant="primary"
              size="small"
              rightIconName="chevron-down"
              onClick={onPress}
            >
              {displayLabel}
            </ButtonLink>
          )}
        />
      </CollaboratorActions>
    </CollaboratorRowContainer>
  );
};
